import { TextInput, Form, FormField } from "grommet";
import React from "react";
import { PopUp } from "./popup";
export type IBoughtOneProps = {
    setShow: (value: boolean) => void,
    addPurchase: () => void,
    item_type: string,
}

export const IBoughtOne: React.FC<IBoughtOneProps> = (props: IBoughtOneProps) => {
    const { setShow, item_type, addPurchase } = props;
    const [value, setValue] = React.useState({} as { [key: string]: any });
    const handleSubmit = (event: any) => {
        event.currentTarget.disabled = true;
        fetch('' + process.env.REACT_APP_API_BASE_URL + '/api/registry',
            {
                method: 'POST',
                headers: new Headers({ "Access-Control-Allow-Origin": "*", "Content-Type": "application/json" }),
                body: JSON.stringify({
                    itemType: item_type,
                    name: value["firstName"] + " " + value["lastName"],
                })
            }).then(_ => {
                addPurchase();
                setShow(false);
            })
    };

    return (

       <PopUp title="Thank you!" description="What is your name?" buttonText="submit" onButtonClick={handleSubmit} setShow={setShow}>
                <Form onSubmit={handleSubmit} value={value}
                    onChange={nextValue => {
                        setValue(nextValue);
                        console.log(nextValue);
                    }} style={{ width: "100%" }}>
                    <FormField name="firstName" htmlFor="first-name" label="First Name" required >
                        <TextInput id="first-name" name="firstName" defaultValue="" plain={false} />
                    </FormField>
                    <FormField name="lastName" htmlFor="last-name" label="Last Name" required >
                        <TextInput id="last-name" name="lastName" plain={false} />
                    </FormField>
                </Form>
        </PopUp>
    );
}
